export default __webpack_public_path__ + "static/media/product_4.3.2df1cebb.png";